// S11 AI reports (M11): every Editor and Admin views and scores them (poc CT-008).
import { createFileRoute } from '@tanstack/react-router';
import { AiReportsPage } from '@/features/admin/ai-reports/AiReportsPage';
import { parseReportSearch } from '@/features/admin/ai-reports/report-data';
import { requireStaffSession } from '@/lib/session';

export const Route = createFileRoute('/ai-reports')({
  validateSearch: parseReportSearch,
  beforeLoad: ({ context, location }) => requireStaffSession(context.queryClient, location.href),
  component: AiReportsRoute,
});

function AiReportsRoute() {
  return <AiReportsPage search={Route.useSearch()} />;
}
